import { render, staticRenderFns } from "./PurchaseFormView.vue?vue&type=template&id=04b667ca"
import script from "./PurchaseFormView.vue?vue&type=script&lang=js"
export * from "./PurchaseFormView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports